/**
 * Розділи статті з якорями.
 *
 * Один перелік на два місця: зміст на сторінці статті й переходи просто в
 * розділ із картки на /blog. Якщо якір зміниться тут, обидва місця й самі
 * розділи статті підхоплять його разом — розійтися їм нема де.
 *
 * Якорі латиницею: кирилиця в адресі після копіювання стає %D0%A9… і в
 * листі чи месенджері вже не читається.
 */
export const SECTION_IDS = {
  changes: 'shcho-zminylosya',
  risk: 'ryzyk',
  todo: 'shcho-robyty',
  sources: 'pershodzherela'
};

export const SOURCES_TITLE = 'Першоджерела';

export const todoGroupId = (i) => `${SECTION_IDS.todo}-${i + 1}`;

export const articleSections = (article) => [
  { id: SECTION_IDS.changes, title: article.changesTitle },
  { id: SECTION_IDS.risk, title: article.riskTitle },
  {
    id: SECTION_IDS.todo,
    title: article.todoTitle,
    children: article.todo.map((group, i) => ({ id: todoGroupId(i), title: group.title }))
  },
  { id: SECTION_IDS.sources, title: SOURCES_TITLE }
];
